/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// components
import SoftBox from "components/SoftBox";

// example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// table
import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import { InvoiceBooksService } from "services/invoiceBooksService";

const renderData = (items, setDataTable) => {
  return items.map((item) => ({
    id: item._id,

    name: item.name,
    invoiceSymbol: item.invoiceSymbol,
    invoiceSample: item.invoiceSample,
    from: item.from,
    to: item.to,
    dayActive: item.dayActive,
    supplierName: item.supplierName,
    supplierTaxCode: item.supplierTaxCode,
    numberOfRegistrations: item.numberOfRegistrations,
    active: item.isActive ? "Đang sử dụng" : "Hết hạn",
    used: item.used || 0,

    action: <ActionCell item={item} setDataTable={setDataTable} />,
  }));
};

const tableData = {
  columns: [
    {
      Header: "Tên loại hoá đơn",
      accessor: "name",
    },
    {
      Header: "Mẫu số",
      accessor: "invoiceSymbol",
    },
    {
      Header: "Ký hiệu",
      accessor: "invoiceSample",
    },
    {
      Header: "Số lượng",
      accessor: "numberOfRegistrations",
    },
    {
      Header: "Từ số",
      accessor: "from",
    },
    {
      Header: "Đến số",
      accessor: "to",
    },
    {
      Header: "Ngày bắt đầu sử dụng",
      accessor: "dayActive",
    },
    {
      Header: "Doanh nghiệp in/Doanh nghiệp cung cấp phần mềm",
      accessor: "supplierName",
    },
    {
      Header: "MST",
      accessor: "supplierTaxCode",
    },
    {
      Header: "Actions",
      accessor: "action",
      align: "right",
    },
  ],
  rows: [],
};

function InvoiceBooks() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({
    sortBy: "createdAt",
    sortType: "desc",
    searchBy: "",
  });
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const queryParams = {
        ...query,
        limit: paginationData.size,
        page: paginationData.page,
      };

      const {
        data: { items, paginate },
      } = await InvoiceBooksService.getAll(queryParams);

      setPaginationData((prev) => ({
        ...prev,
        count: paginate.count,
        size: paginate.size,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items, setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Load invoice books error:", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default InvoiceBooks;
